// extracted by mini-css-extract-plugin
export var footer = "_kz-0";
export var inherit = "_kz-1";
export var input = "_kz-2";
export var modalContent = "_kz-3";
export var quillEditor = "_kz-4";
export var subtitle = "_kz-5";